/* eslint-disable max-lines */
/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Fonts, Spacings } from '@styles/index';
import H2 from '@base/H2/H2';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import P1 from '@base/P1/P1';
import H3 from '@base/H3/H3';

const Line = styled.li`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-primary);
  margin: 0px;
`;

const StyledH3 = styled(H3)`
  margin: ${Spacings.SPACING_6B} 0;
`;

const Terms = () => {
  const { pathname, query } = useRouter();
  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>
      <RightContainer>
        {query.in_app !== 'true' && (
          <H2 as="h1">Terms & Conditions – Unacademy Compete</H2>
        )}
        <br />
        <br />
        <br />
        <P1>
          Unacademy Contest Term and Conditions (“<strong>Contest Terms</strong>
          ”) is made available to you by M/s Sorting Hat Technologies Private
          Limited (collectively referred to as “<strong>us</strong>” “
          <strong>we</strong>” “<strong>Unacademy</strong>”). These Contest
          Terms govern the relationship between persons who wish to participate
          in contests that are made available and organized by Unacademy (“
          <strong>Contest(s)</strong>”) to the users of www.unacdemy.com and/or
          the Unacademy Apps (referred to as “
          <strong>Unacademy Platform</strong>”) either remotely or in person
          (collectively referred to as “<strong>you</strong>” ”
          <strong>your(s)</strong>” “<strong>Participant(s)</strong>”). The
          Participants and Unacademy shall be collectively referred to as
          Parties and individually as Party. The terms and conditions and
          privacy policies and other policies made available on the Unacademy
          Platform (“
          <strong>Platform Terms</strong>”) shall be valid and binding on all
          Participants. All capitalized terms not defined herein shall have the
          meaning assigned to it under the Platform Terms. Unacademy shall from
          time to time communicate contest specific terms and conditions that
          shall also be binding on the Participants (“
          <strong>Contest Specific Terms</strong>”). The Platform Terms, Contest
          Terms and any other Contest Specific Terms shall collectively be
          referred to as “<strong>Terms and Conditions</strong>”. By
          participating in the Contest, the Participant agrees to be bound by
          the Terms and Conditions
        </P1>
        <StyledH3>Eligibility and Enrolment</StyledH3>
        <ol>
          <Line>
            In order to be a Participant in the Contests, the Participants must
            conform to the following eligibility criteria (unless specified
            otherwise) in addition to eligibility criteria in the Contest
            Specific Terms:
          </Line>
          <ol type="a">
            <Line>an Individual;</Line>
            <Line>an Indian citizen;</Line>
            <Line>in India;</Line>
            <Line>legally eligible to enter into a contract;</Line>
            <Line>user of the Unacademy Platform;</Line>
          </ol>
          <Line>
            The Contests are open to participation by individuals only.
            Corporate entities, agencies and any non-human legal entities are
            barred from participating in the Contest. Employees, consultants,
            interns and educators of Unacademy are not allowed to participate in
            Contests conducted by Unacademy.
          </Line>
          <Line>
            The Participants may be required to pay a participation or enrolment
            fee in order to take part in the Contest the details of which shall
            be as specified in the Contest Specific Terms.
          </Line>
          <Line>
            Participants are not bound in any way to participate in the
            Contests. Any participation is voluntary, and the Contest is being
            made available purely on a best effort basis. Unacademy, in its sole
            discretion, reserves the right to disqualify the Participant from
            the benefits and Rewards of the Contest, if any fraudulent activity
            is detected or on any breach of the Terms and Conditions by the
            Participant.
          </Line>
        </ol>
        <StyledH3>Ranking and Rewards</StyledH3>
        <ol>
          <Line>
            Each Contest shall have its own specific selection criteria, ranking
            and rewards system as specified in the Contest Specific Terms.
            Subject to the Contest Specific Terms, Unacademy may, at its sole
            discretion, choose to reward Participants who won the Contest (“
            <strong>Rewards</strong>”).
          </Line>
          <Line>
            Unacademy reserves the right at its sole discretion to modify,
            withdraw, suspend, extend, add reschedule or cancel the Contest or
            the Rewards under the Contests at any time without any prior written
            notice.
          </Line>
          <Line>
            The Participants understands that obtaining a high rank in any
            Contest does not automatically qualify them for Rewards under the
            Contest and shortlisting of Participants is based on selection
            parameters of Unacademy set out in the Contest Specific Terms, as
            determined by Unacademy in its sole discretion.
          </Line>
          <Line>
            The shortlisted Participants may be contacted and be required to
            submit additional information / documentation as may be essential
            for Unacademy to provision the Rewards. Unacademy does not accept
            any responsibility for any incorrect and/or incomplete communication
            details provided and/or delay in receipt of communication and/or
            non-receipt of communication.
          </Line>
          <Line>
            Finally, upon collection and verification of the required
            documentation (as required), Rewards shall be processed to the
            shortlisted Participants within timeline as maybe determined by
            Unacademy at its sole discretion.
          </Line>
          <Line>
            Unacademy shall have the sole discretion to reject the Participant
            or choose another Participant in place of the originally shortlisted
            Participant if: (a) the documents or details provided by the
            Participant are invalid/incorrect/incomplete/ misleading /untrue or
            not acceptable in the opinion of Unacademy; (b) the Participant has
            not conformed to any of the terms and conditions contained herein;
            (c) the Participant does not sign the consent form or any other
            documents required, if any, by Unacademy concerning the Contest; (d)
            any other reason as may be deemed appropriate by Unacademy.
          </Line>
          <Line>
            The process of selection, number of Participants shortlisted for the
            Rewards and the type or form of Reward are to be determined, and
            shall be subject to change, at the sole discretion of Unacademy and
            the decision of Unacademy shall be final and binding. The
            Participants are encouraged to check the Terms on a periodic basis
            to ensure that they do not miss out on any updates and
            modifications.
          </Line>
        </ol>
        <StyledH3>Personal Information</StyledH3>
        <ol>
          <Line>
            A Participant’s Personal Information, including Sensitive Personal
            Information, that may be collected to enable the Contest, provide
            ancillary services related to the Contest and delivery of the
            Rewards, shall be collected, processed, and stored in accordance
            with the Unacademy’s Privacy Policy. Participants shall have all the
            rights available to them under the applicable Data Protection Laws
            in accordance with the Unacademy Privacy Policy.
          </Line>
          <Line>
            Unacademy shall use a Participant’s Personal Information for
            facilitating Contests and rendering the Services with respect to the
            Platform in the most effective manner, to secure the Platform and
            make improvements, to perform market research and product analysis,
            to carry out Unacademy’s obligations towards the Participant, and to
            communicate with the Participant. The said communication can either
            be by calls, text, or emails and for the purposes of conducting the
            Contest itself, transactional, service, advertising or promotional
            calls or messages about the Contest(s) and other offers, new
            products or services made available by Unacademy and the Participant
            hereby consents to the same. Any deletion request received from a
            Participant in respect of their Personal Information shall be
            processed in accordance with Unacademy Privacy Policy.
          </Line>
          <Line>
            Notwithstanding the foregoing, in the event a Participant has
            already received a Reward prior to a deletion request / withdrawing
            consent for use of its information, Unacademy shall comply with such
            request as per the terms of the Privacy Policy, subject to the said
            Participant refunding/returning the reward received by such
            Participant pursuant to these Contest Terms.
          </Line>
        </ol>
        <StyledH3>Consent and Waiver by Participants</StyledH3>
        <ol>
          <Line>
            The Participant hereby consents to the use by Unacademy of his/her
            name, age, photograph, videos, voice recordings, rank, statements
            and/or testimonials (“<strong>Personal Attributes</strong>”) for the
            purpose of publication, advertising, promotion on its online
            platforms, including but not limited to the Unacademy Platform, and
            through any mode, medium, platform and/or format, including without
            limitation, in newspapers, magazines, other print media, on
            television, radio, internet and other electronic and/or in mailings
            for educational awareness.
          </Line>
          <Line>
            Any testimonial or statements provided by the Participant and any
            other details pertaining to the Contest, the Rewards they have won,
            their use of the Platform, content available on the Platform, shall
            be exclusively provided to Unacademy and the Participant warrants to
            that extent.
          </Line>
          <Line>
            Any marketing material created by Unacademy using a Participant’s
            Personal Attributes shall remain the sole property of Unacademy, and
            the Participant shall have no claim of any nature against the same.
            The Participant understands that the use of his/her Personal
            Attributes by Unacademy shall be made at its sole discretion without
            any further notice to the Participant. Unacademy shall have no
            obligation to consider Participant’s inputs or feedback on the use
            of his/her Personal Attributes.
          </Line>
          <Line>
            The Participant shall release, waive, and discharge claims of any
            kind or nature arising out of or relating to the use of his/her
            Personal Attributes against Unacademy or any person or firm
            authorized by Unacademy to publish the same in accordance with the
            terms hereof. Such release, waiver and discharge shall also extend
            to all group companies, affiliated companies, subsidiaries,
            shareholders, directors, officers, employees, agents and assigns of
            Unacademy and any publishers of the Personal Attributes in
            accordance with the terms hereof. Such a release shall be binding on
            the Participant, his/her respective successors, heirs, assigns,
            executors, administrators, spouse and next of kin.
          </Line>
          <Line>
            The Participant hereby confirms that the chance provided by
            Unacademy to be recognized as winner in the Contest(s) and delivery
            of Rewards if any, in accordance with these Contest Terms, is
            sufficient consideration for the use of Participant’s Personal
            Attributes by Unacademy in accordance with the terms hereof, and
            Unacademy shall have no liability to pay any consideration for any
            use of the Participant’s Personal Attributes in accordance with
            these Contest Terms.
          </Line>
        </ol>
        <StyledH3>General Terms and Conditions</StyledH3>
        <ol>
          <Line>
            Information that is available on the official Contest page or
            communicated on Unacademy’s official social media handles shall be
            the only authentic and valid information with respect to the
            Contests. Unacademy shall not be responsible for any
            incorrect/misleading information relating to the Contest, presented/
            displayed on any other source other than the Contest page
            on Unacademy Platform shall not be liable for any loss suffered by
            any Participants based on the representation, Terms, the information
            presented/displayed on any other source other than the Contest page
            on the Unacademy Platform.
          </Line>
          <Line>
            A Participant who has received a Reward for one Contest shall not be
            eligible for the Reward in the next edition of the same Contest,
            unless allowed specifically in the Contest Specific Terms. A
            Participant who has received a Reward under the sub-category of one
            Contest shall not be eligible for Rewards under another sub-category
            in the same Content irrespective of the Ranking.
          </Line>
          <Line>
            After the results are announced, Unacademy will conduct a thorough
            evaluation to determine if the Participants have conducted
            themselves in accordance with the Terms.
          </Line>
          <Line>
            If at any point in time it is brought to the attention or knowledge
            of Unacademy that the Participant have engaged in any unethical
            practices including but not limited to having prior access to the
            questions in the Contest, usage of any circumventing technology to
            manipulate the product algorithm or any act which will give the
            Participant an unfair advantage over other Participants, engaged in
            any form of mal-practice, Unacademy may at its sole discretion
            cancel any Reward or reward due to the Participant and bar the
            Participant for using any product or services offered by Unacademy.
          </Line>
          <Line>
            All Rewards are subject to the Participants adhering to the Terms
            and Conditions and shall be subject to the laws of India, including
            all the applicable tax laws.
          </Line>
          <Line>
            Unacademy has endeavored to make all reasonably practicable
            arrangements to minimize communication system difficulties or any
            other technical issues but can make no guarantee thereof and shall
            not be liable for any failures in the same. Unacademy shall not be
            responsible and/or liable in any manner whatsoever in case the
            Participant is unable to participate due any technical issues or due
            to the issues with their internet provider, hardware, facility
            provider, etc.
          </Line>
          <Line>
            Any Participant found participating in the Test through multiple
            accounts or in the event any person impersonates a Participant, such
            Participant(s) shall be disqualified immediately and shall not be
            entitled to any Rewards. The Participant shall be barred from
            participating in any future Contests, tests etc. at the sole
            discretion of Unacademy.
          </Line>
          <Line>
            Any Participant taking part in Contest and is declared winner in the
            Contest by Unacademy and is unable to fulfil any one or more
            eligibility requirements, as specified in the Terms shall be
            disqualified from receiving any Reward. Any communication,
            clarification, query, dispute in this regard by the Participant, or
            any of the legal heirs/guardians of the Participant in any manner
            shall not be entertained by Unacademy.
          </Line>
          <Line>
            Unacademy will not be responsible, in case anyone is unable to
            participate in the Contest on account of not having access to the
            Contest.
          </Line>
          <Line>
            Participant/s winning the Reward/s shall be contacted by Unacademy
            via email or any other mode of communication. Unacademy shall not be
            liable for any loss, claim, damage, expenses whether expressed,
            implied, real, or consequential incurred by the Participant due to
            participation, non-participation or otherwise in the Contest.
            Unacademy shall not be liable for any loss that occurs during the
            dispatch of the Reward to the Participant’s address Unacademy shall
            not be responsible for paying any applicable taxes, fee, charges,
            etc. related to the Reward.
          </Line>
          <Line>
            Any query regarding the Contest will be entertained only for 1 (one)
            month from date of the participation in the Contest. Post such
            timeframe, Unacademy will not entertain any correspondence or
            communication regarding the Contest from any person.
          </Line>
          <Line>
            Unacademy shall not be responsible for any deficiency in the Rewards
            and does not make a representation about the quality, make,
            performance, features, endurance, finishing, benefits, or fitness of
            the Rewards and neither does Unacademy endorse the services or goods
            provided by the manufacturers/service providers of the Rewards.
          </Line>
          <Line>
            Any disputes with respect to Contest shall subject to be governed by
            and construed in accordance with the laws of India, without
            reference to principles of conflict of laws and the courts in
            Bangalore shall have the exclusive jurisdiction to determine any
            disputes arising out of, under, or in relation to, the Contest.
          </Line>
          <Line>
            The Participant shall indemnify and hold harmless Unacademy, its
            officers, employees, agents, licensees, etc against any and all
            damages, claims, losses, demands, actions, causes of action, suits,
            litigation, costs and expenses (including but not limited to, the
            publication of response(s) submitted by the Participant as a part
            of, or in association with the Contest without limitation,
            reasonable attorneys’ and consultants’ fees).
          </Line>
          <Line>
            Unacademy shall not be liable for any failure to comply with its
            obligations caused by weather conditions, fire, flood, strike,
            hurricane, industrial dispute, war, hostilities, terrorist attack,
            political unrest, riots, civil commotion, inevitable accidents,
            pandemic and/or epidemic, acts of God or any other circumstances
            amounting to Force Majeure.
          </Line>
          <Line>
            Unacademy shall not be responsible for any loss or damage if
            Unacademy is required to discontinue or cancel the Contest in
            compliance with any law, ruling, order, regulation, requirement, or
            instruction of any Central/State Government or for any other
            unavoidable reason beyond its control. The Participants shall be
            informed of such discontinuance/cancellation as early as possible.
          </Line>
          <Line>
            The aggregate liability of Unacademy in case of any damage, loss,
            cost, claim, liability, or expense (including legal costs and
            expenses) caused to or incurred by any act, omission, or
            representation in respect of the Reward, shall not exceed any
            participation or enrolment fee paid for the Contest. Further,
            Unacademy shall not be liable to share the invoice of the Reward
            with the Participant at any given point of time whatsoever.
          </Line>
        </ol>
        <StyledH3>Disclaimers</StyledH3>
        <ol>
          <Line>
            Unacademy and/or its subsidiaries/affiliates shall not be under any
            obligation to the Participant in relation to the Contest and the
            Participant shall have no claims whatsoever against Unacademy and/or
            its subsidiaries/affiliates relating to the selection process,
            gratification, or the running of the Contest.
          </Line>
          <Line>
            Unacademy shall not be responsible for any errors or omissions in
            the terms and conditions contained herein. All information provided
            is provided “as is” without warranty of any kind. To the fullest
            extent permitted by applicable law, Unacademy disclaims all
            warranties, express or implied, including without limitation,
            implied warranties of merchantability, fitness for a particular
            purpose, and non-infringement in respect of the Contest
          </Line>
          <Line>
            Unacademy shall have the sole discretion to discontinue / cancel the
            Contest or any part thereof at any point in time and the Participant
            shall not raise any claim due to such discontinuation or
            cancellation at any time whatsoever.
          </Line>
          <Line>
            Unacademy shall not be held responsible in case of a server shutdown
            or loss of Participants’ registration and/or other data. Unacademy
            shall not be responsible for any delay in receipt or non-receipt or
            incomplete or corrupt receipt of the registration or, other details
            of the Participant. Unacademy shall not be responsible for any
            technical difficulties or data corruption that may arise during the
            registration process. Further, Unacademy shall not be responsible
            and/or liable in any manner whatsoever in case the Participant is
            unable to register for participation in the Contest due to failure
            on part of the internet service provider, facility provider, etc.
          </Line>
        </ol>
        <StyledH3>
          Contest Specific Terms & Conditions – Unacademy Compete
        </StyledH3>
        <ol>
          <Line>
            The Unacademy Compete (“<strong>Compete</strong>”) is a contest
            organized by M/s Sorting Hat Technologies Private Limited (“
            <strong>Unacademy</strong>”) and / or its Affiliate(s) from October
            3, 2022 till November 1, 2022. Compete shall be governed by the
            Contest Terms and the following terms and conditions (“
            <strong>Compete Terms</strong>”) as well as the terms and conditions
            and privacy policies and other policies made available on
            www.unacdemy.com and/or the Unacademy Apps (referred to as “
            <strong>Unacademy Platform</strong>”). Compete Terms and terms and
            conditions on the Unacademy Platform shall be collectively referred
            to as “<strong>Terms</strong>”.
          </Line>
          <Line>
            There shall be no enrollment fee applicable to participate in
            Compete.
          </Line>
          <Line>
            Compete is a contest which encourages each Participant(defined
            below) to participate in Matches (defined below) with other
            Participants who are matched with each other on the Platform based
            on their ratings and other factors as determined by Unacademy.
          </Line>
          <Line>
            Each match is a live match and consists of five questions (“
            <strong>Match(es)</strong>”) and the winner of each Match is decided
            based on the number of correct answers. In case of a tie, the time
            taken to answer and the difficulty level of the questions are taken
            into account to decide the winner of a Match.
          </Line>
          <Line>
            Any person who meets the eligibility criteria (as provided below)
            and participates in Compete shall be considered a “
            <strong>Participant</strong>”.
          </Line>
          <Line>
            To participate in Compete, the Participant must be (i) an
            individual; (ii) an Indian citizen (iii) must have age and
            educational qualifications within the limits defined for eligibility
            of the specific exam that they have selected as their goals.
            Unacademy shall verify the information based on the criteria
            mentioned herein provided by the Participants. If any of these
            criteria are not met, Unacademy may, at its sole discretion,
            withhold any prizes or rewards.
          </Line>
          <Line>
            Compete is presently open for participation by Participants on the
            Unacademy Android app who have selected IIT JEE or NEET UG as their
            goals and/or such other categories as determined by Unacademy from
            time to time and communicated on the Platform.
          </Line>
          <Line>
            Participants’ performance on the Matches are monitored on
            leaderboards which rank Participants based on the number of Matches
            they have won.
          </Line>
          <Line>
            The top five (5) rankers on the main leaderboard at the end of each
            fifteen (15) days are eligible for Rewards provided they have played
            at least fifty (50) Matches in the preceding fourteen (14) days (“
            <strong>Winners</strong>”).
          </Line>
          <Line>
            Winners are eligible to receive the following Rewards:
            <ol type="a">
              <Line>1st prize: Laptop</Line>
              <Line>2nd prize: Amazon voucher worth ₹10K</Line>
              <Line>3rd prize: Amazon voucher worth ₹7.5K</Line>
              <Line>4th prize: Amazon voucher worth ₹5K</Line>
              <Line> 5th prize: Amazon voucher worth ₹2.5K</Line>
            </ol>
          </Line>
          <Line>
            A Participant shall not be eligible to Rewards more than once under
            Unacademy Compete.
          </Line>
        </ol>
        <StyledH3>FAQs on Compete</StyledH3>
        <ol>
          <Line>
            What are the rules of a Compete match?
            <p>
              A Compete match consists of 5 questions spread across multiple
              subjects. You and your opponent get 45-60 seconds to answer the
              question. In case a question is not answered within the set time
              limit, both the learners progress to the next question
              concurrently. Learners cannot go back to the attempted or skipped
              questions. At the end of a match, a winner is announced and the
              leaderboard is updated.
            </p>
          </Line>
          <Line>
            How is the winner of a match decided?
            <p>
              The winner is decided based on three parameters: Accuracy,
              difficulty, and the time taken for all attempts. Accuracy is the
              primary parameter and the remaining two parameters are used for
              tie-breakers. The lower the time taken, the higher the chances to
              win a match. Correctly attempting difficult questions improves a
              learner’s chances to win the match.
            </p>
          </Line>
          <Line>
            How would I know if I am winning or losing a match?
            <p>
              The system starts computing and showcasing the winner, on a
              real-time basis, right from the very first question of the match.
              The winner is represented with a Crown, just next to the learner’s
              name. The Crown keeps on moving between the learners based on
              their performance in the match.
            </p>
          </Line>
          <Line>
            Which questions are fetched during a match?
            <p>
              Questions are sourced from a new set of chapters every month for
              Class 11th and Class 12th students. The syllabus for each month
              has been displayed in detail below. Class 13 / Dropper students
              compete on the entire syllabus throughout the year
            </p>
          </Line>
          <Line>
            My opponent is not answering the questions. Should I continue the
            match?
            <p>
              Yes, you should continue answering the questions. There is a
              chance that your opponent is unsure of the correct answer and has
              chosen to skip the questions. It is also possible that the other
              learner might be experiencing internet issues.
            </p>
          </Line>
          <Line>
            Can I join back a match after I quit it?
            <p>
              A match remains active till all the 5 questions are surfaced to at
              least one of the learners. If a match is active, both the learners
              can join back at any time. Joining a match is not possible once it
              ends.
            </p>
          </Line>
          <Line>
            How am I matched with an opponent?
            <p>
              Learners with a similar level of preparation and ratings are
              usually matched with one another.
            </p>
          </Line>
          <Line>
            Can I request a rematch with someone?
            <p>
              Once the match is over, you and your opponent get 5 seconds to
              start a rematch. If both of you agree to the rematch in these 5
              seconds, a new match starts immediately. However, if only one
              learner agrees to a rematch, there is no rematch.
            </p>
          </Line>
          <Line>
            What rating system is used in the leaderboard?
            <p>
              The Elo system is used to rate the learners on the platform. It
              takes into account the current rating and performance of you and
              your opponent. It will get updated after every Compete. Learners
              with higher Elo ratings have a higher rank on the leaderboard. In
              case 2 learners have the same rating, the player who wins more
              Competes is ranked higher. Your ranking would change based on the
              performance of other learners over time. Learners who compete
              regularly are more likely to stay on top of the leaderboard.
            </p>
          </Line>
          <Line>
            How can I win prizes in Compete?
            <p>
              The top 5 learners on the Goal level leaderboard would receive the
              following awards:
              <ol type="a">
                <Line>1st prize: Laptop</Line>
                <Line>2nd prize: Amazon voucher worth ₹10K</Line>
                <Line>3rd prize: Amazon voucher worth ₹7.5K</Line>
                <Line>4th prize: Amazon voucher worth ₹5K</Line>
                <Line> 5th prize: Amazon voucher worth ₹2.5K</Line>
              </ol>
              Prizes are announced every 15 days. However, you need to play a
              minimum of 50 matches successfully in the preceding 14 days to be
              eligible for any of the prizes.
            </p>
          </Line>
        </ol>
      </RightContainer>
    </>
  );
};

Terms.pageInfo = {
  name: 'Unacademy Compete Terms',
  isMWebSupported: true,
  layoutOptions: {
    disableDarkMode: true
  }
};

export default Terms;
Terms.Layout = Layout;
Terms.Wrapper = PageReduxProvider;
